.rv-container {
  display: flex;
  padding: 16px;
  position: relative;
  border: 1px solid #eee;
  border-radius: 7px;
  flex-direction: column;
  height: 202px;
  overflow: auto;
  line-height: 21px;
  box-sizing: border-box;

  * {
    font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
      Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  }
}
